import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  sectionMargins,
  standardColours,
  brandColours,
  brandFonts,
  fontSize,
  standardTransition,
  visuallyHidden,
} from '../styles';
import { Container, Heading, HtmlContent } from './ui';

const StyledTabs = styled.section`
  ${sectionMargins()};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 40px;
  `}
`;

const StyledList = styled.ul`
  display: flex;
  flex-direction: column;

  ${minBreakpointQuery.tiny`
    flex-direction: row;
  `}
`;

const StyledItem = styled.li`
  flex-grow: 1;
`;

const StyledTab = styled.button`
  padding: 20px 10px;
  height: 100%;
  width: 100%;
  color: ${standardColours.grey};
  font-family: ${brandFonts.primary};
  ${fontSize(16)};
  line-height: 1.5;
  background: none;
  border: none;
  border-bottom: 2px solid ${standardColours.lighterGrey};
  cursor: pointer;
  ${standardTransition('border-color')};

  ${({ active }) => {
    if (active) {
      return css`
        color: ${brandColours.primary};
        border-bottom-color: ${brandColours.primary};
      `;
    }
  }}

  ${minBreakpointQuery.medium`
    ${fontSize(18)};
  `}
`;

const StyledContent = styled.article`
  margin: 40px 0;

  ${({ active }) => {
    if (!active) {
      return `
        ${visuallyHidden()};
      `;
    }
  }}
`;

const StyledContentHeading = styled.h3`
  ${visuallyHidden()};
`;

export const Tabs = ({ heading, items }) => {
  const [activeTabId, setActiveTabId] = useState(items[0].id);

  return (
    <StyledTabs>
      <Container narrow={true}>
        <StyledHeading alt={true}>{heading}</StyledHeading>
        <StyledList>
          {items.map(({ id, heading }) => (
            <StyledItem>
              <StyledTab
                active={id === activeTabId}
                onClick={() => {
                  setActiveTabId(id);
                }}
              >
                {heading}
              </StyledTab>
            </StyledItem>
          ))}
        </StyledList>
        {items.map(({ id, heading, content }) => (
          <StyledContent key={id} active={id === activeTabId}>
            <StyledContentHeading>{heading}</StyledContentHeading>
            <HtmlContent html={content} />
          </StyledContent>
        ))}
      </Container>
    </StyledTabs>
  );
};

export default Tabs;
